// src/firebase/firebaseConfig.ts
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

// Environment detection
const isProduction = process.env.NODE_ENV === "production";

//#region : Development/Test project credentials
const devFirebaseConfig = {
	apiKey: "AIzaSyDpNumQarUOX3xsH2Ri4M0ULKMYmTDVlIo",
	authDomain: "fir-react-6738c.firebaseapp.com",
	databaseURL: "https://fir-react-6738c-default-rtdb.firebaseio.com",
	projectId: "fir-react-6738c",
	storageBucket: "fir-react-6738c.firebasestorage.app",
	messagingSenderId: "583285753100",
	appId: "1:583285753100:web:5041c94b3720ab36137529"
};
//#endregion

//#region : Production project credentials
const prodFirebaseConfig = {
	apiKey: "AIzaSyBIJ6ulYVWZLgLLFimmeeCXvGZSakzs9MA",
	authDomain: "fashionbazi-billing.firebaseapp.com",
	databaseURL: "https://fashionbazi-billing-default-rtdb.firebaseio.com",
	projectId: "fashionbazi-billing",
	storageBucket: "fashionbazi-billing.firebasestorage.app",
	messagingSenderId: "585807484457",
	appId: "1:585807484457:web:c142bacfc761bcfe72ae38"
};
//#endregion

// Select configuration based on environment
const firebaseConfig = isProduction ? prodFirebaseConfig : devFirebaseConfig;

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getDatabase(app);
